// src/components/trackinginfo/api/trackingInfoApi.js
// ============================================================================
// BLOCK TI.API.0 — Tracking Info API Client (Axios)
// Why axios?
// - Your app already uses axiosClient.js which likely attaches auth automatically
// - Fixes 401 caused by fetch() not including your auth headers/interceptors
// ============================================================================

// ============================================================================
// BLOCK TI.API.0 — Tracking Info API Client (Axios)
// ============================================================================

import axios from '../../../axiosClient.js';

export default async function fetchTrackingRows({
  year = null,
  month = null,
  rep = null,
  offset = 0,
  limit = 250,
}) {
  const res = await axios.get('/api/trackinginfo', {
    params: {
      year,
      month,
      rep,
      offset,
      limit,
    },
  });

  return res.data;
}
